var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInspectionservice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 10.4727V15.306L16.9167 17.7227",
    stroke: "#FF6019",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.93164 13.5453C6.14553 11.4744 7.12499 9.55358 8.68314 8.14941C10.2413 6.74523 12.2691 5.95597 14.3796 5.93219C16.4901 5.90842 18.5356 6.6518 20.1259 8.0205C21.7162 9.38921 22.7399 11.2874 23.0016 13.353C23.2634 15.4186 22.745 17.5069 21.5453 19.2196C20.3456 20.9322 18.3478 22.4695 16.2963 22.9588C10.1085 23.7924 7.70603 19.6213 6.66478 18.3376M6.66478 21.7497V18.3376M6.66478 18.3376H10.0696",
    stroke: "#FF6019",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspectionservice);
export default __webpack_public_path__ + "static/media/inspectionservice.e9730a96.svg";
export { ForwardRef as ReactComponent };